module.exports = __webpack_public_path__ + "media/intro.04c9efc6.mp3";